/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

/**
 * Terms for UI
 */
export const uiTerms = {
	events: {
		messages: {
			actionHasFailed: "events:messages.actionHasFailed#message",
			actionNotAllowed: "events:messages.actionsNotAllowed#message",
			methodHasFailed: "events:messages.methodHasFailed#message",
			valueIsNotMethod: "events:messages.valueIsNotMethod#message"
		},
		types: {
			authAllowed: "events:types.authAllowed#label",
			conditionResult: "events:types.conditionResult#label",
			dialogResult: "events:types.dialogResult#label",
			dialogButtonId: "events:types.dialogButtonId#label",
			dialogCustomData: "events:types.dialogCustomData#label",
			methodError: {
				label: "events:types.methodError#label",
				nameLabel: "events:types.methodError.name#label",
				messageLabel: "events:types.methodError.message#label"
			},
			variableValue: "events:types.variableValue#label",
			setReturnValue: "events:types.setReturnValue#label",
			setErrorValue: "events:types.setErrorValue#label"
		}
	}
};
